import React, { lazy, Suspense, useEffect, useState } from 'react';
import { seismicTheme, Theme } from '@seismic/mantle';
import { getSeismicAuthToken } from 'utils/centralAuthToken';

const AsyncUAR = lazy(() =>
  import(
    /* webpackChunkName: "UAR" */ '@seismic/universal-audio-recorder'
  ).then(module => ({
    default: module.UniversalAudioRecorder,
  })),
);

const UARecorder = props => {
  const { isOpen, onCancel, onUARReady, bssUploadOptions, handleComplete } =
    props;
  const [seismicAuthToken, setSeismicAuthToken] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const token = await getSeismicAuthToken();
      setSeismicAuthToken(token);
      setLoading(false);
    })();
  }, []);
  useEffect(() => {
    if (!loading) {
      if (typeof onUARReady === 'function') {
        onUARReady();
      }
    }
  }, [onUARReady, loading]);

  return (
    <Theme theme={seismicTheme({ useGlobal: true })}>
      {!loading && (
        <Suspense fallback={null}>
          <AsyncUAR
            open={isOpen}
            onCancel={onCancel}
            getAuthToken={() => seismicAuthToken}
            bssUploadOptions={bssUploadOptions}
            onComplete={handleComplete}
          />
        </Suspense>
      )}
    </Theme>
  );
};

export default UARecorder;
